import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { get } from 'lodash';
import { DatadogRumService } from '../../services';
import { GoogleAnalyticsService } from '../../services';
import { LoggerService } from '../../services';
import { TaggedLogger } from '../../services';

import { environment } from '../../../environments/environment';
import { filter, map } from 'rxjs/operators';

/**
 * A root component, outlays a parent router outlet
 * todo: nested nav, login check and redirect to account
 * todo: potentially also "back to where you were" login link
 */
@Component({
  selector: 'app-root',
  templateUrl: './app-root.component.html',
})
export class AppRootComponent implements OnInit {
  private logger: TaggedLogger;
  private gtmId: string;
  private appTitle: string;

  /**
   * @constuructor
   */
  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService,
    loggerService: LoggerService,
  ) {
    this.logger = loggerService.taggedLogger('AppRoot');
    this.appTitle = AppRootComponent.getAppTitle();
  }

  /**
   * ngOnInit sets the page title when the route changes
   */
  async ngOnInit() {
    this.logger.trace('ngOnInit()');

    this.updateTitleOnRouteChange();
    this.googleAnalyticsService.init();

    this.logger.trace('ngOnInit() finished');
  }

  /**
   * Attaches to router events to update the page title when the page changes
   * @private
   */
  private updateTitleOnRouteChange() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }

          const pageTitle = child.snapshot.data['title'];
          if (pageTitle) {
            return `${pageTitle} - ${this.appTitle}`;
          }

          return this.appTitle;
        }),
      )
      .subscribe((title: string) => {
        this.logger.trace('Setting Title', title);
        this.title.setTitle(title);
      });
  }

  private static getAppTitle() {
    return get(environment, 'title.suffix', '');
  }
}
